<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
        <h2>浩范食堂管理软件</h2>
        <h2>让食堂管理更简单！</h2>
        <img src="@/assets/img/admin/admin.png" alt />
      </header>
    </div>

    <main>
      <title>智慧食堂管理软件</title>
      <ul class="layoutMaxWidth">
        <li>
         <img src="@/assets/img/admin/a1.png" alt />
          <h2>多方账号管理</h2>
          <p>根据团餐管理的特点，团餐公司、物业方、企业客户可直接在网页登录所授权的不同账号，根据自己的需求和权限进行操作</p>
        </li>
        <li>
          <img src="@/assets/img/admin/a2.png" alt />
          <h2>多种消费模式</h2>
          <p>支持针对食堂的多种消费模式；固定金额按次消费、后付费消费、自选组合消费、扫码消费等</p>
        </li>
        <li>
           <img src="@/assets/img/admin/a3.png" alt />
          <h2>数据报表清晰</h2>
          <p>根据团餐公司的需求特别设计的日报表、月报表和多种数据查询方式</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "card",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
 .header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    height: 437px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 144px;
      font-size: 56px;
      padding-bottom: 31px;
    }
    h2:nth-of-type(2){
      padding-top: 10px;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
      line-height: 40px;
    }
    img {
      position: absolute;
      top: 71px;
      right: 0px;
      width: 216px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") center no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 600px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px /*px*/;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      margin-top: 61px;
      align-items: center;
      li {
        background-color: white;
        padding: 74px 34px 0;
        margin-right: 17px;
        margin-top: 16px;
        width: 32.5%;
        height: 314px;
        box-sizing: border-box;
        text-align: center;
        img {
          width: 54px;
        }
        h2 {
          font-size: 16px /*px*/;
          color: $primary-color;
          margin-top: 26px;
        }
        p {
          margin-top: 26px;
          font-size: 11px /*px*/;
          line-height: 1.8em;
          text-align: left;
        }
      }
      li:nth-child(3n) {
        margin-right: 0px;
      }
      li:nth-of-type(2){
        h2{
          margin-top: 34px;
        }
      }
    }
  }
}
</style>